'use client';

import { c as _c } from "react/compiler-runtime";
import { useApi } from '@repo/api';
import { useQuery } from '@repo/tanstack/query';
export type CmdkUser = {
  email: string;
  id: number;
  last_name?: null | string;
  name: string;
};
export const useCmdkUsers = (search, t0) => {
  const $ = _c(9);
  const perPage = t0 === undefined ? 10 : t0;
  const api = useApi();
  let t1;
  if ($[0] !== search) {
    t1 = search.trim();
    $[0] = search;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = t1.length >= 1;
  let t3;
  if ($[2] !== api.users.list || $[3] !== perPage || $[4] !== search) {
    t3 = api.users.list.queryOptions({
      input: {
        perPage,
        search: search.trim()
      }
    });
    $[2] = api.users.list;
    $[3] = perPage;
    $[4] = search;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      enabled: t2,
      ...t3,
      staleTime: 30000
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return useQuery(t4);
};